import styled from 'styled-components';

export const Container = styled.div`
    min-height: calc(100vh - 100px);
    height: calc(100vh - 100px);
    background: ${({ theme }) => theme.colors.lighterGray};
    padding: 40px 56px;
    overflow: auto;
`;
